import {System} from "tick-knock";
import {PlayerType} from "@game/coregame/interfaces/PlayerType";
import {EventDispatcher, lazyGet} from "@dp-instant/core";
import {TypesCore} from "@dp-instant/interfaces";
import {ContinentModel} from "@game/coregame/model/ContinentModel";
import {GameEvents} from "@game/coregame/GameEvents";
import {StateShapeView} from "@game/coregame/view/StateShapeView";

export class InitStageSystem extends System {
    constructor(private currentContinent: ContinentModel, private stageLevel: number) {
        super();
    }

    onAddedToEngine() {
        super.onAddedToEngine();
        const texturesPreparationPromises: (Promise<void> | undefined)[] = [];
        this.currentContinent.parsed.forEach((data, id) => {
            const building = this.currentContinent.getOrCreateBuildingEntity(id, data);
            this.engine.addEntity(building);
            const stageLevelProgress = this.stageLevel - data.stage;
            if (stageLevelProgress === 0) {
                building.setStartOwner(data.startOwner);
            } else if (stageLevelProgress > 0) {
                building.setStartOwner(PlayerType.First);
            } else {
                building.setStartOwner(PlayerType.Neutral);
            }
            building.setInactive(stageLevelProgress !== 0);
            texturesPreparationPromises.push(building.get(StateShapeView)?.initialPromise);
        });
        Promise.all(texturesPreparationPromises).then(() => {
            lazyGet<EventDispatcher>(TypesCore.dispatcher)?.emit(GameEvents.LEVEL_LOADED);
        });
        this.engine.removeSystem(this);
    }
}
